import styled from 'styled-components';
import { Button, Spin } from 'antd';
import { ScrollbarStyles } from 'hyarchis-global';
import DataStatusIcon from './processing-jobs/DataStatusIcon';
import { COLOR_INACTIVE } from '../../app-constants';

const FlexBox = styled.div`
  display: flex;
`;

const FlexColumn = styled(FlexBox)`
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
`;

const CenteredSpinner = styled(Spin)`
  align-content: center;
`;

const LeftColumn = styled(FlexBox)`
  width: 40%;
`;

const MiddleColumn = styled(FlexBox)`
  width: 20%;
`;

const RightColumn = styled(FlexBox)`
  width: 40%;
`;

const FileDropAreaWrapper = styled.div`
  width: 100%;
  margin-right: 40px;
`;

const ActionIconsWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: none;
`;

const Wrapper = styled(FlexBox)<{ color?: string }>`
  border: 1px solid #e0e0e0;
  padding: 10px 16px;
  justify-content: space-between;
  height: 96px;
  width: 100%;
  border-color: ${({ color }) => color ?? COLOR_INACTIVE};
  position: relative;
  &:hover ${ActionIconsWrapper} {
    display: block;
  }
`;

const GroupWrapper = styled(Wrapper)`
  height: 115px;
`;

const HeadIconWrapper = styled.div`
  padding: 15px;
  font-size: 35px;
`;

const HeadingWrapper = styled(FlexColumn)`
  margin-left: 10px;
  overflow: hidden;
`;

const SubTitleWrapper = styled(FlexBox)`
  height: 100%;
  align-items: center;
`;

const HeadTitleWrapper = styled(SubTitleWrapper)`
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
`;

const ResultTitleWrapper = styled(SubTitleWrapper)`
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  height: 100%;
  display: flex;
  align-items: center;
`;

const ResultIconsWrapper = styled(ResultTitleWrapper)`
  font-size: 18px;
`;

const DateTimeWrapper = styled.div`
  margin-left: auto;
  margin-right: 25px;
`;

const CollapseTogglerWrapper = styled.div`
  align-self: center;
  margin: 0 8px;
`;

const DownloadButton = styled(Button)`
  margin-left: 12px;
`;

const SmallIconSpan = styled.span`
  margin-right: 8px;
`;

const JobTitle = styled.span`
  font-weight: bold;
  font-size: 12px;
  margin-right: 4px;
`;

const JobValue = styled.span`
  font-size: 12px;
  cursor: pointer;
`;

const HeadTitle = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const DateTimeItem = styled.div`
  margin: 2px 0;
`;

const StyledStatusIcon = styled(DataStatusIcon)`
  margin-right: 16px;
`;

const StyledMatchStatusIcon = styled(DataStatusIcon)`
  margin-right: 6px;
  margin-left: 6px;
`;

const StyledOutputTitle = styled.span<{ disabled: boolean }>`
  color: ${({ disabled }) => (disabled ? 'grey' : 'inherit')};
`;

const StyledTextAreaWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 45px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 92.5%;
  overflow: auto;
  .ant-input {
    ${ScrollbarStyles}
  }
`;

export default {
  LeftColumn,
  RightColumn,
  MiddleColumn,
  CenteredSpinner,
  FileDropAreaWrapper,
  Wrapper,
  GroupWrapper,
  HeadIconWrapper,
  HeadingWrapper,
  HeadTitleWrapper,
  ResultIconsWrapper,
  DateTimeWrapper,
  CollapseTogglerWrapper,
  DownloadButton,
  SmallIconSpan,
  JobTitle,
  JobValue,
  HeadTitle,
  DateTimeItem,
  StyledStatusIcon,
  StyledMatchStatusIcon,
  StyledOutputTitle,
  SubTitleWrapper,
  FlexColumn,
  ResultTitleWrapper,
  FlexBox,
  ActionIconsWrapper,
  StyledTextAreaWrapper,
};
